module.exports = {
	"Play": "Reproducció",
	"Pause": "Pausa",
	"Current Time": "Temps reproduït",
	"Duration Time": "Durada total",
	"Remaining Time": "Temps restant",
	"Stream Type": "Tipus de seqüència",
	"LIVE": "EN DIRECTE",
	"Loaded": "Carregat",
	"Progress": "Progrés",
	"Fullscreen": "Pantalla completa",
	"Non-Fullscreen": "Pantalla no completa",
	"Mute": "Silencia",
	"Unmute": "Amb so",
	"Playback Rate": "Velocitat de reproducció",
	"Subtitles": "Subtítols",
	"subtitles off": "Subtítols desactivats",
	"Captions": "Llegendes",
	"captions off": "Llegendes desactivades",
	"Chapters": "Capítols",
	"You aborted the media playback": "Heu interromput la reproducció del vídeo.",
	"A network error caused the media download to fail part-way.": "Un error de la xarxa ha interromput la baixada del vídeo.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "No s'ha pogut carregar el vídeo perquè el servidor o la xarxa han fallat, o bé perquè el seu format no és compatible.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La reproducció de vídeo s'ha interrumput per un problema de corrupció de dades o bé perquè el vídeo demanava funcions que el vostre navegador no ofereix.",
	"No compatible source was found for this media.": "No s'ha trobat cap font compatible amb el vídeo."
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/ca.json
// module id = 181
// module chunks = 81